import React from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./styles.css";
import successIcon from "assets/images/success.svg"

const ToastMsg = (msg, type, component = <></>) => {
	switch (type) {
		case "error": {
			toast.error(msg, {
				autoClose: 5000,
				bodyClassName: "toast-container",
				className: "toast-basic toast-error",
				progressClassName: "toast-progress",
				closeButton: false,
			});
			break;
		}
		default: {
			toast(msg, {
				icon: () => <img src={successIcon} />,
				autoClose: 5000,
				bodyClassName: "toast-container",
				className: "toast-basic toast-warn",
				progressClassName: "toast-progress",
				closeButton: false,
			});
			break;
		}
	}
};

export default ToastMsg;
